import { Modal, ModalActions, ModalContent, ModalHeader } from "@/components/bp/bp-ui";
import { confirmAlert } from "react-confirm-alert";
import { BPButton } from "@/components/bp/bpbutton";

export function areYouSure(optBuilder: () => { title?: string, message: string }) {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        let ptr = descriptor.value;
        let t = target;

        descriptor.value = function (...args) {

            var dlgOpts = optBuilder();

            return new Promise(resolve => {
                confirmAlert({
                    customUI: opt => {
                        return <Modal open={true}>
                            {dlgOpts.title && <ModalHeader> {dlgOpts.title}</ModalHeader>}
                            <ModalContent>{dlgOpts.message}</ModalContent>
                            <ModalActions>
                                <BPButton negative onClick={() => {
                                    let result = ptr.apply(this, args);
                                    opt.onClose();
                                    resolve(result);
                                }}>
                                    {window.translation.common.yes}
                                </BPButton>
                                <BPButton onClick={() => {
                                    opt.onClose();
                                    resolve(null);
                                }}>
                                    {window.translation.common.cancel}
                                </BPButton>
                            </ModalActions>
                        </Modal>
                    },

                });
            });
        };

        return descriptor;
    };
}

export function areYouSure2(optBuilder: { title?: string, message: string, action: () => any }) {
    var dlgOpts = optBuilder;

    return new Promise(resolve => {
        confirmAlert({
            customUI: opt => {
                return <Modal open={true}>
                    {dlgOpts.title && <ModalHeader> {dlgOpts.title}</ModalHeader>}
                    <ModalContent>{dlgOpts.message}</ModalContent>
                    <ModalActions>
                        <BPButton negative onClick={() => {
                            let result = dlgOpts.action()
                            // let result = ptr.apply(this, args);
                            opt.onClose();
                            resolve(result);
                        }}>
                            {window.translation.common.yes}
                        </BPButton>
                        <BPButton onClick={() => {
                            opt.onClose();
                            resolve(null);
                        }}>
                            {window.translation.common.cancel}
                        </BPButton>
                    </ModalActions>
                </Modal>
            },

        });
    });
}

